module.exports = __webpack_public_path__ + "img/avatar2.130e4ffd.jpg";